/** Organization > Billing (docs/product/billing.md). */
export const BILLING_PATH = '/organization/billing';

/**
 * Window event the axios client dispatches when the paywall answers a 402
 * (`BILLING_SEAT_LIMIT_REACHED`); `BillingPaywallListener` opens the upgrade
 * dialog. Its `detail` is the 402's `BillingSeatLimitDetails`.
 */
export const BILLING_SEAT_LIMIT_EVENT = 'kollabhr:billing-seat-limit';

/** Stripe Checkout sends the browser back with `?payment=saved|cancelled`. */
export const PAYMENT_RETURN_PARAM = 'payment';

export const PAYMENT_RETURN = {
  Saved: 'saved',
  Cancelled: 'cancelled',
} as const;

export const BILLING_INVOICES_PAGE_SIZE = 10;

/** Card brand names as Stripe reports them; anything else is capitalized. */
export const CARD_BRAND_NAMES: Record<string, string> = {
  amex: 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  unionpay: 'UnionPay',
  visa: 'Visa',
};
